<script>
import {usePropertyStore} from "@/stores/modules/property.module";
import PropertyItemUser from "@/components/property/PropertyItemUser.vue";
import {useMapStore} from "@/stores/modules/map.module";

export default {
  name: "SavedProperties",
  components: {PropertyItemUser},
  setup(){
    const propertyStore = usePropertyStore();
    const mapStore  = useMapStore();
    const userLocation = mapStore.getUserPositionLngLat;
    return{
      propertyStore,
      userLocation
    }
  },
  created() {
    this.loadPage(0);
  },
  computed:{
    properties() {
      return this.propertyStore.savedProperties.content;
    },
    page(){
      return this.propertyStore.savedProperties.currentPage;
    },
    loading(){
      return this.propertyStore.savedProperties.loading;
    }
  },
  methods:{
    async loadPage(page) {
      let location = await this.userLocation;
      await this.propertyStore.fetchSavedProperties(page, location);
    }
  }
}
</script>

<template>
  <v-skeleton-loader
      v-if="loading"
      type="image"
  >
  </v-skeleton-loader>
  <div v-else-if="!properties || properties.length<=0">
    <div class="text-center">Keine gespeicherten Immobilien</div>
  </div>
  <div v-else style="gap:15px" class="d-flex justify-start flex-column">
    <PropertyItemUser can-create-offer v-for="property of properties" :key="property.id" :property="property"/>
    <v-pagination :start="0" v-model="page.number" :length="page.totalPages" @update:modelValue="loadPage"/>
  </div>

</template>

<style scoped>

</style>